<template>
  <div class="news-block" v-loading="typeLoading">
    <!-- 新闻分类-->
    <NewsType :data="newsTypes" v-model="typeIndex" @change="typeChange" />
    <!--分类下的新闻列表-->
    <div class="flex flex-row" v-loading="newsLoading">
      <Carousel />
      <div class="flex-1 list">
        <div
          v-for="(list, index) in newsList[typeIndex]"
          :key="index"
          class="list-item"
        >
          <div class="list-title ellipsis pointer" @click="toDetail(list)">
            {{ list.articleTitle }}
          </div>
          <div class="list-time">{{ list.publishTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ARTICLE_TYPE } from "@/constant/dict";
import { queryNewsList } from "@/api/article";
import { parseTime } from "@/utils";
import NewsType from "./NewHead";
import Carousel from "./Carousel";
export default {
  components: {
    NewsType,
    Carousel,
  },
  data() {
    return {
      typeIndex: 0,
      typeLoading: false,
      newsLoading: false,
      newsTypes: [],
      newsList: { 0: [], 1: [], 2: [], 3: [], 4: [] },
    };
  },
  created() {
    this.getDict();
  },
  methods: {
    toDetail(data) {
      this.$jump.push({ name: "newsDetail", query: { id: data.articleId } });
    },
    // 获取数据字典
    async getDict() {
      this.typeLoading = true;
      const data = await this.$store
        .dispatch("getDictData", ARTICLE_TYPE)
        .finally(() => {
          this.typeLoading = false;
        });
      // 文章类型（1-新闻资讯;2-展会信息;3-政策法规;4-规格介绍;5-帮助文档;6-APP新闻资讯;7-检测助手;
      // 8-业务助手;9-检测标准;10-检测方法;11-资质要求;12-平台快讯 13）
      // const types = [ARTICLE_TYPE_XWTG, ARTICLE_TYPE_XWZX, ARTICLE_TYPE_ZCFG];
      const result = data.slice(0, 3);
      this.newsTypes = result;
      this.getNewsList();
    },
    async getNewsList() {
      const news = this.newsList[this.typeIndex];
      if (news && news.length) return;
      this.newsLoading = true;
      const { list } = await this.$axios
        .post(queryNewsList, {
          articleType: this.newsTypes[this.typeIndex].dictValue,
          pageIndex: 1,
          pageSize: 6,
        })
        .finally(() => {
          this.newsLoading = false;
        });
      list.forEach((item) => {
        Object.assign(item, {
          publishTime: parseTime(item.publishTime, "{yyyy}-{m}-{d}"),
        });
      });
      this.newsList[this.typeIndex] = list;
    },
    typeChange() {
      this.getNewsList();
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/style/variable";
.news-block {
  margin-bottom: 24px;
}
.list {
  height: 348px;
  &-item {
    margin-bottom: 14px;
    padding-left: 24px;
    font-size: 16px;
    line-height: 24px;
    color: #333;
    width: 380px;

    position: relative;
    &:hover {
      color: $theme-color;
    }
    // &::before {
    //   position: absolute;
    //   left: 0;
    //   top: 10px;
    //   content: "";
    //   display: inline-block;
    //   width: 6px;
    //   height: 6px;
    //   border-radius: 3px;
    //   background: linear-gradient(to bottom, #7aebfd, #2f64f7);
    // }
  }
  &-title {
    max-width: 380px;
  }
  &-time {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 14px;
  }
}
</style>
